// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"e478e5e9","580":"e29b0112"}[chunkId] + ".chunk.css";
};